import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db, storage } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  deleteDoc,
} from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";

function AdminSingleProductPage() {
  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const productUid = params.productUid;

  const [productObject, setProductObject] = useState();
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState("");
  const [activeFrom, setActiveFrom] = useState("");
  const [activeTo, setActiveTo] = useState("");

  const fetchProduct = async () => {
    try {
      setIsLoading(true);

      const q = query(
        collection(db, "products"),
        where("uid", "==", productUid)
      );
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setProductObject(data);
      setName(data.name);
      setCategory(data.category);
      setPrice(parseFloat(data.price));
      setImage(data.image);
      setActiveFrom(data.activeFrom ? data.activeFrom : null);
      setActiveTo(data.activeTo ? data.activeTo : null);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching product data");
    }
  };

  useEffect(() => {
    if (productUid) {
      fetchProduct();
    }
    // eslint-disable-next-line
  }, [productUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this product?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const productRef = query(
            collection(db, "products"),
            where("uid", "==", productUid)
          );
          const findProducts = await getDocs(productRef);
          findProducts.forEach(async (productObject) => {
            const getProduct = doc(db, "products", productObject.id);
            await updateDoc(getProduct, {
              name: name,
              price: price,
              activeFrom: activeFrom,
              activeTo: activeTo,
            }).then(() => {
              fetchProduct();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  const deleteProduct = async () => {
    Swal.fire({
      text: "Are you sure you want to delete this product?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, DELETE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);

          const productRef = query(
            collection(db, "products"),
            where("uid", "==", productUid)
          );
          const findProducts = await getDocs(productRef);
          findProducts.forEach(async (productObject) => {
            const getProducts = doc(db, "products", productObject.id);
            await deleteDoc(getProducts);
          });

          Swal.fire({
            text: "Product deleted successfully",
            icon: "success",
            confirmButtonColor: "#005EE1",
            confirmButtonText: "OKAY",
          });

          navigate(-1);

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          alert("An error occured while deleting product");
        }
      }
    });
  };

  const [changeProductImageModalIsOpen, setChangeProductImageModalIsOpen] =
    useState(false);
  const toggleChangeProductImageModal = () => {
    setChangeProductImageModalIsOpen(!changeProductImageModalIsOpen);
  };
  const [isModalLoading, setIsModalLoading] = useState(false);

  const [newProductImage, setNewProductImage] = useState();
  const [newProductImagePreview, setNewProductImagePreview] = useState();

  const handleChangeNewProductImage = (e) => {
    setNewProductImage(e.target.files[0]);
    setNewProductImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewProductImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewProductImage = async () => {
    const storageRef = ref(storage, `assets/products/${newProductImage.name}`);
    const uploadTask = uploadBytesResumable(storageRef, newProductImage);
    setIsModalLoading(true);
    uploadTask.on(
      "state_changed",
      null,
      (error) => console.log(error),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          console.log("File available at", downloadURL);
          try {
            setNewProductImage(downloadURL);

            const productRef = query(
              collection(db, "products"),
              where("uid", "==", productUid)
            );
            const findProducts = await getDocs(productRef);
            findProducts.forEach(async (product) => {
              const getProduct = doc(db, "products", product.id);
              await updateDoc(getProduct, {
                image: downloadURL,
              });
            });

            fetchProduct();

            setIsModalLoading(false);
            toggleChangeProductImageModal();
          } catch (err) {
            console.error(err);
            alert(err.message);
            setIsModalLoading(false);
          }
        });
      }
    );
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        PRODUCT
      </h1>
      <div>
        <div
          onClick={toggleChangeProductImageModal}
          id="adminNewsArticleImageContainer"
        >
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button className="primaryBtn">CHANGE</Button>
          </div>
        </div>
        <Modal
          id="changeNewsArticleImageModal"
          isOpen={changeProductImageModalIsOpen}
          toggle={toggleChangeProductImageModal}
          size={"lg"}
        >
          <ModalBody>
            <div className="modalHeader" style={{ marginBottom: "1rem" }}>
              <div></div>
              <IoClose onClick={toggleChangeProductImageModal} />
            </div>
            <div>
              <h1>CHANGE IMAGE</h1>
              {isModalLoading ? (
                <div
                  style={{
                    height: 300,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <BarLoader color="#005EE1" />
                </div>
              ) : (
                <div style={{ marginTop: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <img
                      alt="articleImage"
                      src={
                        newProductImagePreview
                          ? newProductImagePreview
                          : image
                          ? image
                          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                      }
                      style={{ height: 250, width: 651.4 }}
                    />
                  </div>
                  <Input
                    id="selectImage"
                    type="file"
                    className="mainInput"
                    accept="image/*"
                    onChange={handleChangeNewProductImage}
                    style={{ display: "none" }}
                  />
                  <Button
                    onClick={selectNewProductImage}
                    className="secondaryBtn"
                    style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                  >
                    {newProductImage?.name
                      ? newProductImage.name
                      : "CHOOSE IMAGE"}
                  </Button>
                  <Button
                    onClick={handleUploadNewProductImage}
                    disabled={!newProductImage?.name}
                    className="primaryBtn"
                  >
                    CHANGE
                  </Button>
                </div>
              )}
            </div>
          </ModalBody>
        </Modal>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The product's name"
          style={{ marginBottom: "0.5rem" }}
          disabled={category === "SPORTS PASS"}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Category
        </p>
        <input
          type="text"
          className="mainInput"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="The product's category"
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Price
        </p>
        <input
          type="number"
          className="mainInput"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="The product's price"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Active from
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={activeFrom}
          onChange={(e) => setActiveFrom(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
          // disabled={new Date(group?.openingDateTime) < new Date()}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Active to
        </p>
        <Input
          type="datetime-local"
          className="mainInput"
          value={activeTo}
          onChange={(e) => setActiveTo(e.target.value)}
          style={{ marginBottom: "0.5rem" }}
          // disabled={new Date(group?.openingDateTime) < new Date()}
        />
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginTop: "0.5rem" }}
          disabled={
            name === productObject?.name &&
            category === productObject?.category &&
            price === productObject?.price &&
            activeFrom === productObject?.activeFrom &&
            activeTo === productObject?.activeTo
          }
        >
          SAVE
        </Button>
        <Button
          onClick={deleteProduct}
          className="secondaryBtn"
          style={{ marginTop: "0.5rem" }}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
}

export default AdminSingleProductPage;
